// reelConfig.ts

export const REEL_COLLECTION_COUNT = 2;
export const REEL_NUMBERS = 6;
export const SYMBOLS_PER_REEL = 6;
export const SYMBOL_WIDTH = 135;
export const SYMBOL_HEIGHT = 132;
export const REEL_WIDTH = SYMBOL_WIDTH;
export const REEL_DIVIDER = 1;
export const REEL_FRAME = 0;
export const NUMBER_OF_SYMBOLS = 11;
export const SHOWN_REELS_HEIGHT = SYMBOL_HEIGHT * SYMBOLS_PER_REEL;

// import { TextStyle } from "pixi.js";

// export const WILD_MULT_STYLE = new TextStyle({
//     fontFamily: 'Arial',
//     fontSize: 100,
//     fill: "#fed716",
//     fontWeight: "bold",
//     stroke: '#4a1850',
//     dropShadow: true,
// });